// src/utils/accountFilter.ts
import { Account } from "@/types/metrics";
import { BrandConfig } from "@/types/brand";

/**
 * Filters accounts for display in the main account selector dropdown.
 *
 * @param allAccounts - The unfiltered list of all accounts.
 * @param brandConfig - The configuration for the current brand.
 * @returns A filtered list of accounts.
 */
export const filterAccountsForSelector = (
  allAccounts: Account[],
  brandConfig: BrandConfig | null,
): Account[] => {
  if (!brandConfig) {
    // If brand config is not loaded, default to showing all accounts.
    return allAccounts;
  }

  // White-label clients are identified by not showing sales pages.
  // For them, we hide the sample account from the dropdown.
  if (brandConfig.features?.salesPages === false) {
    return allAccounts.filter((account) => !account.isSampleAccount);
  }

  // For the default 8020agent brand, show all accounts including the sample one.
  return allAccounts;
};
